import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, unref as _unref, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6c0b7983"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "flex ml-2 mt-2" }
const _hoisted_3 = { class: "breadcrumb" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " > ", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "active" }, "予約詳細", -1))
const _hoisted_6 = {
  id: "direct-messages-right-sidebar",
  class: "flex justify-content-start align-items-center flex-wrap"
}
const _hoisted_7 = { class: "flex custom-detail-title" }
const _hoisted_8 = {
  key: 0,
  class: "breadcrumb"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " > ", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "active" }, "顧客詳細", -1))
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "flex align-items-right right-button" }

import { AnyFn, get, set, templateRef } from "@vueuse/core";
import TabView from "primevue/tabview";
import TabPanel from "primevue/tabpanel";
import { useToast } from "primevue/usetoast";
import Profile from "./Profile.vue";
import BookingHistory from "./BookingHistory.vue";
import BookingDetail from "./BookingDetail.vue";
import CustomerTagView from "@/clinic/views/common/customer/tag/index.vue";
import { onBeforeMount, ref, inject, nextTick } from "vue";
import { AccountServices } from "@/clinic/services";
import RouterConstants from "@/clinic/constants/router.constants";
import RouterUtils from "@/common/utils/router.util";
import type { ICustomer, ITag, IBooking } from "@/clinic/typings";
import { BookingViewTypeEnum, BookingActionEnum } from "@/clinic/typings/enums/booking";
import { RouteLocationRaw } from "vue-router";
import DialogMergeHotpepper from "@/clinic/views/Customer/components/List/DialogMergeHotpepper.vue";
import SpecialNote from "@/clinic/views/Customer/components/rightSidebar/CustomerDetail/SpecialNote.vue";
import { useStore } from "vuex";
import { ClinicPartner } from "@/clinic/typings/enums/clinic";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    clinicId: null,
    customerId: null,
    accountId: null,
    customer: null,
    tags: null,
    hasLinkCustomer: { type: Boolean }
  },
  emits: ["linkedCustomerSuccess", "refreshCustomer"],
  setup(__props: any, { emit: emits }) {

const props = __props as {
  clinicId: number;
  customerId: number;
  accountId: number;
  customer: ICustomer;
  tags: ITag[];
  hasLinkCustomer: boolean;
};

const store = useStore();
const toast = useToast();
const clinicId = ref(0);
const isShowDetail = ref<boolean>(false);
const viewType = ref<string>(BookingViewTypeEnum.Day);


const showBookingDetail = ref<InstanceType<typeof BookingDetail> | null>(null);
const onShowBookingDetail = (booking: IBooking, action: BookingActionEnum) => {
  showBookingDetail.value?.onShow(booking, action);
};

const loading = ref(false);
const onSetCustomerIdRightSidebar = inject<AnyFn>("onSetCustomerIdRightSidebar");


const dialogMergeHotpepper = templateRef<HTMLElement | null>("dialogMergeHotpepper", null);

const showDialog = async () => {
  get(dialogMergeHotpepper)?.showDialog();
  get(dialogMergeHotpepper)?.setCustomerId(props.customer?.id);
  await get(dialogMergeHotpepper)?.fetchHotpepperCustomer();
};

const goToEdit = (id: number) => {
  const to = {
    name: RouterConstants.CUSTOMER_EDIT_ROUTER_NAME,
    params: { id },
    query: { previous_name: RouterConstants.DIRECT_MESSAGE_ROUTER_NAME },
  } as RouteLocationRaw;
  RouterUtils.goToRaw(to);
};

const successCallback = (cusId: number, accId: number, customer: ICustomer) =>
  emits("linkedCustomerSuccess", { customerId: cusId, accountId: accId, customer });

const errorCallback = () => {
  loading.value = false;
  toast.add({
    severity: "error",
    detail: "何かが間違っています。後でもう一度試してください",
    life: 3000,
  });
};

const linkToCustomer = async (cusId: number, accId: number, customer: ICustomer) => {
  loading.value = true;
  await AccountServices.linkToCustomer(
    get(clinicId).value,
    cusId,
    accId,
    () => successCallback(cusId, accId, customer),
    errorCallback
  );
};

const onBackToCustomerList = () => {
  const setCustomerId = get(onSetCustomerIdRightSidebar) || ((id: number): void => ({ id }));
  setCustomerId(0);
};

const onRefreshCustomer = () => emits("refreshCustomer");

onBeforeMount(async () => {
  set(clinicId, await inject("clinicId"));
});

const onBookingClick = async booking => {
  isShowDetail.value = true;
  await nextTick();
  onShowBookingDetail(booking, BookingActionEnum.show);
};

const backToCustomerDetail = () => {
  isShowDetail.value = false;
};

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!

  return (isShowDetail.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_Button, {
              onClick: backToCustomerDetail,
              class: "p-button-link",
              label: "戻る"
            }),
            _hoisted_4,
            _hoisted_5
          ])
        ]),
        _createVNode(BookingDetail, {
          ref_key: "showBookingDetail",
          ref: showBookingDetail,
          viewType: viewType.value
        }, null, 8, ["viewType"])
      ]))
    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            (__props.hasLinkCustomer)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createVNode(_component_Button, {
                    onClick: onBackToCustomerList,
                    class: "p-button-link",
                    label: "戻る"
                  }),
                  _hoisted_9,
                  _hoisted_10
                ]))
              : (_openBlock(), _createElementBlock("h2", _hoisted_11, "顧客詳細"))
          ]),
          _createElementVNode("div", _hoisted_12, [
            (!__props.hasLinkCustomer)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  label: "ホットペッパー顧客と統合",
                  class: "btn-merge-hotpepper mx-3",
                  onClick: showDialog
                }))
              : _createCommentVNode("", true),
            (!__props.hasLinkCustomer && _unref(store).getters['authClient/selectedClinic'].partner == _unref(ClinicPartner).Unaffiliated)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 1,
                  label: "編集",
                  class: "p-button-light",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (goToEdit(props.customerId)))
                }))
              : _createCommentVNode("", true),
            (__props.hasLinkCustomer)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 2,
                  label: "顧客情報を紐付け",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (linkToCustomer(props.customerId, props.accountId, props?.customer)))
                }))
              : _createCommentVNode("", true)
          ])
        ]),
        _createVNode(_unref(TabView), { class: "customer-detail-content flex-grow-1" }, {
          default: _withCtx(() => [
            _createVNode(_unref(TabPanel), { header: "顧客データ情報" }, {
              default: _withCtx(() => [
                _createVNode(Profile, {
                  customer: props.customer,
                  "list-tags": props.tags,
                  tags: props.customer?.tags || [],
                  comment: props.customer?.comment || '',
                  "clinic-id": props?.clinicId
                }, null, 8, ["customer", "list-tags", "tags", "comment", "clinic-id"])
              ]),
              _: 1
            }),
            _createVNode(_unref(TabPanel), { header: "顧客タグ" }, {
              default: _withCtx(() => [
                _createVNode(CustomerTagView, {
                  customerId: props.customer?.id,
                  listTags: __props.tags,
                  automatic_tags: __props.customer?.automatic_tags,
                  tags: __props.customer?.tags || [],
                  onRefreshCustomer: onRefreshCustomer
                }, null, 8, ["customerId", "listTags", "automatic_tags", "tags"])
              ]),
              _: 1
            }),
            _createVNode(_unref(TabPanel), { header: "予約履歴" }, {
              default: _withCtx(() => [
                _createVNode(BookingHistory, {
                  bookings: props.customer?.bookings || [],
                  onBookingClick: onBookingClick
                }, null, 8, ["bookings"])
              ]),
              _: 1
            }),
            _createVNode(_unref(TabPanel), { header: "特記事項" }, {
              default: _withCtx(() => [
                _createVNode(SpecialNote, {
                  customer: props.customer
                }, null, 8, ["customer"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(DialogMergeHotpepper, {
          ref_key: "dialogMergeHotpepper",
          ref: dialogMergeHotpepper
        }, null, 512)
      ], 64))
}
}

})